<template>
  <v-card class="pa-2">
    <v-skeleton-loader :loading="firstLoad && loading" type="table">
      <v-row no-gutters align="center">
        <v-col cols="12" md="6">
          <h3 class="color-services">
            {{ serviceProvider ? "Service Provider" : "Internal Team" }}
          </h3>
        </v-col>
        <v-col cols="12" md="6">
          <v-row no-gutters justify="end" align="center">
            <v-col v-if="$store.state.isMobile">
              <v-text-field
                outlined
                v-model="search"
                hide-details
                placeholder="Search"
                prepend-inner-icon="mdi-magnify"
                color="indigo accent-3"
                class="search-field"
              ></v-text-field>
            </v-col>

            <v-text-field
              v-if="!$store.state.isMobile"
              outlined
              v-model="search"
              hide-details
              placeholder="Search"
              prepend-inner-icon="mdi-magnify"
              color="indigo accent-3"
              class="pe-3 search-field"
            ></v-text-field>

            <v-btn
              v-if="!serviceProvider"
              color="indigo accent-3"
              class="search-btn ms-2"
              dark
              :to="{
                name: routerPath.clientPanel.children.addClientMember.name,
              }"
            >
              <v-icon left>mdi-plus</v-icon>
              <span v-if="!$store.state.isMobile">Add Internal Team</span>
              <span v-else>Add Team</span>
            </v-btn>

            <v-btn
              v-if="
                serviceProvider &&
                  permissions.indexOf(PermissionKeys.SERVICE_PROVIDER_ADD) > -1
              "
              color="indigo accent-3"
              class="search-btn ms-2"
              dark
              :to="{
                name:
                  routerPath.clientPanel.children.clientServiceProviderAdd.name,
              }"
            >
              <v-icon left>mdi-plus</v-icon>
              <span v-if="!$store.state.isMobile">Add Service Provider</span>
              <span v-else>Add Provider</span>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="mt-2 mb-1"></v-divider>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="pagination"
        :server-items-length="itemsTotal"
        :loading="loading"
        :page.sync="pagination.page"
        mobile-breakpoint="0"
        hide-default-footer
        @page-count="10"
      >
        <template v-slot:[`item.table_id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.id`]="{ item }">
          <v-btn
            text
            color="indigo accent-3"
            style="text-transform: none;"
            small
            :to="{
              name:
                routerPath.clientPanel.children.clientServiceProviderDetails
                  .name,
              params: { id: item.user_details.id },
            }"
          >
            <span>View</span>
          </v-btn>

          <v-btn
            v-if="
              permissions.indexOf(PermissionKeys.SERVICE_PROVIDER_EDIT) > -1
            "
            text
            color="indigo accent-3"
            style="text-transform: none;"
            small
            :to="{
              name:
                routerPath.clientPanel.children.clientServiceProviderEdit.name,
              params: { id: item.user_details.id },
            }"
          >
            <span>Edit</span>
          </v-btn>
        </template>
        <template v-slot:[`item.roles_list`]="{ item }">
          <v-tooltip bottom content-class="tooltip-custom">
            <template v-slot:activator="{ on }">
              <span
                v-on="on"
                style="cursor: pointer;"
                v-for="(element, index) in item.roles_list"
                :key="element.id"
              >
                <!-- {{ element.name }} -->
                {{
                  item.roles_list.length != 1 &&
                  index + 1 != item.roles_list.length
                    ? element.name + ","
                    : element.name
                }}
              </span>
            </template>
            <span v-for="(element, index) in item.roles_list" :key="element.id">
              {{ element.name }}
              <br v-if="index != item.roles_list.length - 1" />
            </span>
          </v-tooltip>
        </template>
        <!-- <template v-slot:item.role_details="{ item }">{{
        item.role_details.name
        }}</template>-->

        <template v-slot:[`item.user_details.is_active`]="{ item }">
          <span :class="getTextColor(item.user_details.is_active)">{{
            item.user_details.is_active ? "Active" : "Inactive"
          }}</span>
        </template>

        <template v-slot:no-data>
          <EmptyState text="Team Member" />
        </template>
      </v-data-table>

      <v-divider class="mt-1 mb-2"></v-divider>
      <v-row align="center" justify-md="end" v-if="!$store.state.isMobile">
        <span class="body-2 text-color" style="margin-end: 73px">
          Showing
          {{
            pagination.itemsPerPage * pagination.page -
              pagination.itemsPerPage +
              1
          }}
          -
          {{
            pagination.itemsPerPage * pagination.page > itemsTotal
              ? itemsTotal
              : pagination.itemsPerPage * pagination.page
          }}
          of {{ itemsTotal }}
        </span>

        <v-btn
          text
          color="indigo accent-3 body-2"
          :disabled="1 == pagination.page"
          @click="pagination.page = pagination.page - 1"
        >
          <span>Previous</span>
        </v-btn>

        <span class="body-2 text-color ms-9 me-9"
          >Page {{ pagination.page }}</span
        >

        <v-btn
          text
          color="indigo accent-3"
          :disabled="
            Math.ceil(itemsTotal / 10) == pagination.page || itemsTotal < 1
          "
          @click="pagination.page = pagination.page + 1"
        >
          <span>Next</span>
        </v-btn>
      </v-row>

      <v-row v-else align="center" justify="center">
        <v-row class="ma-0 pt-2" align="center" justify="center">
          <v-btn
            text
            color="indigo accent-3 body-2"
            :disabled="1 == pagination.page"
            @click="pagination.page = pagination.page - 1"
          >
            <span>Previous</span>
          </v-btn>

          <span class="body-2 text-color ms-9 me-9"
            >Page {{ pagination.page }}</span
          >

          <v-btn
            text
            color="indigo accent-3"
            :disabled="
              Math.ceil(itemsTotal / 10) == pagination.page || itemsTotal < 1
            "
            @click="pagination.page = pagination.page + 1"
          >
            <span>Next</span>
          </v-btn>
        </v-row>
        <v-col cols="12" align="center">
          <span class="body-2 text-color">
            Showing
            {{
              pagination.itemsPerPage * pagination.page -
                pagination.itemsPerPage +
                1
            }}
            -
            {{
              pagination.itemsPerPage * pagination.page > itemsTotal
                ? itemsTotal
                : pagination.itemsPerPage * pagination.page
            }}
            of {{ itemsTotal }}
          </span>
        </v-col>
      </v-row>
    </v-skeleton-loader>
  </v-card>
</template>

<script>
  import { mapGetters } from "vuex";
  import { ROUTER_URL } from "../../../../constants/urls";

  import Keys from "../../../../constants/keys";
  import PermissionKeys from "../../../../constants/PermissionKeys";

  import EmptyState from "../../../../components/EmptyState/EmptyState";

  import ClientApiHelper from "../../../../api/common/ClientApis";
  import AmplitudeHelper from "../../../../amplitude";

  export default {
    name: "ClientMemberList",
    components: {
      EmptyState,
    },
    data() {
      return {
        PermissionKeys: PermissionKeys,
        routerPath: ROUTER_URL,
        items: [],
        search: "",
        itemsTotal: 0,
        loading: true,
        firstLoad: true,
        pagination: { sortBy: ["name"], sortDesc: [false] },
        headers: [
          {
            text: "ID",
            value: "table_id",
            class: "black--text font-weight-bold ",
          },
          {
            text: "Name",
            value: "user_details.name",
            class: "black--text font-weight-bold ",
          },
          {
            text: "Email",
            value: "user_details.registered_email",
            class: "black--text font-weight-bold ",
          },
          {
            text: "Phone",
            value: "user_details.mobile",
            class: "black--text font-weight-bold ",
          },
          {
            text: "Roles",
            value: "roles_list",
            class: "black--text font-weight-bold ",
          },
          {
            text: "Status",
            value: "user_details.is_active",
            class: "black--text font-weight-bold",
            sortable: false,
          },
        ],
        rowsPerPageItems: [5, 10, 20, 50, 100],
        serviceProvider: false,
      };
    },
    computed: {
      ...mapGetters({
        permissions: "mainStore/getPermissions",
      }),
    },
    watch: {
      pagination() {
        if (!this.firstLoad) this.getMemberData();
        this.firstLoad = false;
      },
      search() {
        this.pagination.page = 1;
        this.getMemberData();
      },
    },
    methods: {
      ifInternalTeamList() {
        console.log(
          this.$route.name ==
            ROUTER_URL.clientPanel.children.clientServiceProviderList.name
        );
        return (
          this.$route.name ==
          ROUTER_URL.clientPanel.children.clientServiceProviderList.name
        );
      },

      getMemberData() {
        this.loading = true;

        const successHandler = (res) => {
          this.loading = false;
          this.items = res.data.data;
          this.itemsTotal = res.data.recordsTotal;
        };

        const failureHandler = (res) => {
          console.log(res);
          this.loading = false;
        };

        let dataTableParams = {};
        dataTableParams[Keys.LENGTH] = this.pagination.itemsPerPage
          ? this.pagination.itemsPerPage
          : 10;
        dataTableParams[Keys.PAGE] = this.pagination.page;
        dataTableParams[Keys.SEARCH] = this.search;
        dataTableParams[Keys.IS_SERVICE_PROVIDER] = this.serviceProvider;
        try {
          for (let a = 0; a < this.headers.length; a++) {
            if (
              this.pagination.sortBy.length > 0 &&
              this.pagination.sortBy[0] == this.headers[a].value
            ) {
              dataTableParams[Keys.SORTING_COLUMN] = a;
              dataTableParams[
                Keys.FLAG_DESCENDING
              ] = this.pagination.sortDesc[0];
            }
          }
        } catch (error) {
          console.log(error);
        }

        // let url = "";
        // if (this.serviceProvider) url = API_COMMON_URL.serviceProviderList;
        // else url = API_CLIENT_URL.clientTeamList;
        if (this.serviceProvider)
          ClientApiHelper.getServiceProviderList(
            dataTableParams,
            successHandler,
            failureHandler
          );
        else
          ClientApiHelper.getClientTeamList(
            dataTableParams,
            successHandler,
            failureHandler
          );

        // Axios.request_POST(
        //   url,
        //   dataTableParams,
        //   {},
        //   successHandler,
        //   failureHandler
        // );
      },
      getColor(status) {
        if (status) return "green";
        else return "red";
      },
      getTextColor(status) {
        if (status) return "green--text";
        else return "red--text";
      },
    },
    created() {
      if (
        this.$route.name ==
        ROUTER_URL.clientPanel.children.clientServiceProviderList.name
      ) {
        this.serviceProvider = true;
        this.headers = [
          {
            text: "Name",
            value: "user_details.name",
            class: "black--text font-weight-bold ",
          },
          {
            text: "Email",
            value: "user_details.registered_email",
            class: "black--text font-weight-bold ",
          },
          {
            text: "Phone",
            value: "user_details.mobile",
            class: "black--text font-weight-bold ",
          },
          {
            text: "Roles",
            value: "roles_list",
            class: "black--text font-weight-bold ",
          },
          {
            text: "Status",
            value: "user_details.is_active",
            class: "black--text font-weight-bold",
            sortable: false,
          },
          {
            sortable: false,
            text: "Action",
            value: "id",
            class: "black--text font-weight-bold",
            align: "center",
          },
        ];
      }
      AmplitudeHelper.registerEvent("Internal Team List - View");
    },
    mounted() {
      this.getMemberData();
    },
  };
</script>

<style scoped>
  .color-services {
    color: #5c648b;
  }
</style>
